import { jsx as e, jsxs as i, Fragment as O } from "react/jsx-runtime";
import { useState as y, useRef as Q } from "react";
import { useApp as U } from "../../../context/app/index.js";
import { files as z } from "../../../queries/files/index.js";
import { Q as S, l, m as s, s as V } from "../../../index-DNTqwtVt.js";
import { Avatar as q, alpha as G, Chip as H, Menu as J, MenuItem as L, ListItemIcon as T, ListItemText as I } from "@mui/material";
import { FileLocationEnum as v } from "../../../helpers/daymaptypes.js";
import { B as K } from "../../../index-BcZ70a8s.js";
const ne = ({
  name: F,
  description: g,
  extension: D,
  modified: x,
  fileId: r,
  download: b,
  contentType: k,
  pdf: R,
  onAnnotationsClicked: n,
  location: c,
  path: m,
  selected: A
}) => {
  const { refetch: C } = new z.FileDownLoadLink({ FileId: r ?? 0, ContentProvider: k ?? 0, Pdf: R ?? !1 }).ToQuery(), { nativeDownload: f } = U(), [E, o] = y(!1), p = Q(null), [M, d] = y(!1), P = () => {
    n ? d(!0) : u();
  }, u = async () => {
    if (!b)
      return;
    if (o(!0), c === v.URL && m)
      return await K.open({ url: m }), o(!1), !1;
    const { data: a } = await C();
    if (!a) {
      o(!1);
      return;
    }
    if (f)
      await f(a);
    else {
      const t = document.createElement("a");
      t.href = a, t.click(), t && t.remove();
    }
    o(!1);
  }, { icon: j, color: h } = S(c === v.URL ? "url" : D);
  let B = /* @__PURE__ */ e(q, { variant: "rounded", sx: { height: 30, width: 30, bgcolor: G(h, 0.15), color: h }, children: j }), w = [];
  return n && w.push(/* @__PURE__ */ e(H, { size: "small", label: "Teacher feedback", icon: /* @__PURE__ */ e(l, { iconType: s.Annotations }) }, "annotations")), /* @__PURE__ */ i(O, { children: [
    /* @__PURE__ */ e(V, { itemType: "file", ref: p, onClick: P, title: F, description: g, avatar: B, date: x, loading: E, chips: w, selected: A }),
    /* @__PURE__ */ i(
      J,
      {
        id: "basic-menu",
        anchorEl: p.current,
        open: M,
        onClose: () => d(!1),
        children: [
          /* @__PURE__ */ i(L, { onClick: u, children: [
            /* @__PURE__ */ e(T, { children: /* @__PURE__ */ e(l, { iconType: s.Download }) }),
            /* @__PURE__ */ e(I, { children: "Download file" })
          ] }),
          /* @__PURE__ */ i(L, { onClick: () => n && r && n(r), children: [
            /* @__PURE__ */ e(T, { children: /* @__PURE__ */ e(l, { iconType: s.Annotations }) }),
            /* @__PURE__ */ e(I, { children: "View Annotations" })
          ] })
        ]
      }
    )
  ] });
};
export {
  ne as FileItem
};
//# sourceMappingURL=file.js.map
